import { Box } from '@mui/material';

export default function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<Box
			variant="div"
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && children}
		</Box>
	);
}
